/* Cart + reorder actions (Justin 2026-10-20). Loaded from layout/theme.liquid on every page.
   - Clear cart (snippets/nt-cart-clear.liquid, bottom of the cart page + drawer): confirm, then /cart/clear.js.
   - Master X on a multi-size design card (snippets/nt-design-group-header.liquid): removes every
     size of that design in one /cart/update.js call; the per-size X's stay as they are.
     The blanks size card (assets/nt-blank-card.js) uses the same button to remove a whole color.
   - window.NTReorderReview.open(button, onContinue): when a line of the order is out of stock, the
     order-level Reorder (My Orders + Recent Orders) first shows what will be added and what is out of stock, read from the order's
     snippets/nt-reorder-review-data.liquid JSON; Continue runs the existing add-to-cart flow.
   All handlers are delegated on document, so they survive the cart's innerHTML re-renders. */
(function () {
  if (window.__ntCartActions) return;
  window.__ntCartActions = true;

  var css =
    '.nt-ca-ov{position:fixed;inset:0;z-index:10050;background:rgba(17,17,17,.45);display:flex;align-items:center;justify-content:center;padding:16px;}' +
    '.nt-ca-box{background:#fff;border-radius:14px;box-shadow:0 20px 50px rgba(0,0,0,.25);width:100%;max-width:440px;max-height:calc(100vh - 32px);display:flex;flex-direction:column;overflow:hidden;font-family:inherit;color:#111;}' +
    '.nt-ca-box--wide{max-width:560px;}' +
    '.nt-ca-hd{padding:20px 20px 6px;}' +
    '.nt-ca-title{font-size:18px;font-weight:700;line-height:1.3;margin:0;}' +
    '.nt-ca-msg{font-size:14px;line-height:1.45;color:#555;margin:6px 0 0;}' +
    '.nt-ca-body{padding:8px 20px;overflow-y:auto;}' +
    '.nt-ca-sec{font-size:12px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;color:#717278;margin:12px 0 6px;}' +
    '.nt-ca-row{display:flex;align-items:center;gap:12px;padding:8px 0;border-top:1px solid #f0f0f0;}' +
    '.nt-ca-row:first-of-type{border-top:none;}' +
    '.nt-ca-th{flex:0 0 44px;width:44px;height:44px;border-radius:8px;border:1px solid #eee;background:#f6f6f6;object-fit:contain;}' +
    '.nt-ca-nm{flex:1;min-width:0;font-size:14px;font-weight:600;line-height:1.3;}' +
    '.nt-ca-sub{display:block;font-size:12px;font-weight:400;color:#717278;margin-top:2px;}' +
    '.nt-ca-q{flex:0 0 auto;font-size:13px;color:#555;white-space:nowrap;}' +
    '.nt-ca-row--oos .nt-ca-th{opacity:.45;}' +
    '.nt-ca-row--oos .nt-ca-nm{color:#8a8b91;}' +
    '.nt-ca-tag{flex:0 0 auto;font-size:12px;font-weight:600;color:#6B7280;background:#E5E7EB;border-radius:6px;padding:3px 8px;white-space:nowrap;}' +
    '.nt-ca-ft{display:flex;gap:10px;justify-content:flex-end;padding:14px 20px 20px;border-top:1px solid #f0f0f0;}' +
    '.nt-ca-btn{appearance:none;border-radius:8px;padding:10px 18px;font-size:14px;font-weight:600;line-height:1.2;cursor:pointer;border:1px solid #d6d7db;background:#fff;color:#111;}' +
    '.nt-ca-btn:hover{border-color:#111;}' +
    '.nt-ca-btn--go{background:#019AFF !important;border-color:#019AFF !important;color:#fff !important;}' +
    '.nt-ca-btn--go:hover{background:#0180d4 !important;border-color:#0180d4 !important;}' +
    '.nt-ca-btn--danger{background:#DC2626 !important;border-color:#DC2626 !important;color:#fff !important;}' +
    '.nt-ca-btn--danger:hover{background:#B91C1C !important;border-color:#B91C1C !important;}' +
    '.nt-ca-btn[disabled]{opacity:.5;cursor:default;}' +
    '@media (max-width:480px){.nt-ca-ft{flex-direction:column-reverse;}.nt-ca-btn{width:100%;}}' +
    /* order line items (snippets/order-line-items.liquid): each line carries its display `order` (out-of-stock last,
       Pre-cut under its DTF line); ao-li--vlast = the visually last line */
    ':is(.ao-order-row,.ao-order-row-mobile,.ro-order-row,.ro-order-row-mobile).expanded :is(.ao-line-items,.ro-line-items){display:flex !important;flex-direction:column;}' +
    ':is(.ao-line-items,.ro-line-items) > .ao-line-item{border-bottom:1px solid #ececea;}' +
    ':is(.ao-line-items,.ro-line-items) > .ao-line-item.ao-li--vlast{border-bottom:none;}' +
    /* Pre-cut sub-line hanging under its DTF line: indented, half-size icon, attached (no divider between) */
    ':is(.ao-line-items,.ro-line-items) > .ao-line-item.ao-li--has-pc{border-bottom:none;padding-bottom:2px;}' +
    '.ao-line-item.ao-li-pc-sub{padding-top:2px;padding-left:52px;grid-template-columns:18px 1fr auto auto;gap:12px;}' +
    '.ao-line-item.ao-li-pc-sub .ao-li-pc-thumb{width:18px;height:18px;border-radius:4px;}' +
    '.ao-line-item.ao-li-pc-sub .ao-li-name{font-size:12px;font-weight:600;}' +
    '.ao-line-item.ao-li-pc-sub .ao-li-sub{font-size:12px;margin-top:0;}' +
    '.ao-line-item.ao-li-pc-sub .ao-li-price{font-size:12px;}' +
    '@media (max-width:768px){.ao-line-item.ao-li-pc-sub{grid-template-columns:18px 1fr;padding-left:52px;}.ao-line-item.ao-li-pc-sub .ao-li-price{grid-column:2;margin-top:0;}.ao-line-item.ao-li-pc-sub .ao-li-reorder{display:none;}}' +
    '@media (min-width:769px){.ao-line-item .ao-li-reorder{width:140px;display:flex;flex-direction:column;align-items:flex-end;}' +
      '.ao-line-item .ao-li-price{width:96px;text-align:left;}' +
      '.ao-line-item .ao-li-reorder-btn{min-width:110px;}.ao-line-item .ao-li-shopall{text-align:right;}}' +
    /* "Adding Reorder to Cart" loader */
    '.nt-ca-load{position:fixed;inset:0;z-index:10060;background:rgba(255,255,255,.75);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;}' +
    '.nt-ca-spin{width:44px;height:44px;border:4px solid #d6ecff;border-top-color:#019AFF;border-radius:50%;animation:ntCaSpin .8s linear infinite;}' +
    '.nt-ca-load p{margin:0;font-size:16px;font-weight:600;color:#111;}' +
    '.nt-ca-load p.nt-ca-load-sub{margin-top:-8px;font-size:14px;font-weight:400;color:#555;}' +
    '@keyframes ntCaSpin{to{transform:rotate(360deg);}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var decEl = document.createElement('textarea');
  function dec(s) { decEl.innerHTML = String(s == null ? '' : s); return decEl.value; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* opts: title, msg, body (html), okText, okClass, wide, onOk(close, okBtn) */
  function modal(opts) {
    var ov = document.createElement('div');
    ov.className = 'nt-ca-ov';
    ov.innerHTML =
      '<div class="nt-ca-box' + (opts.wide ? ' nt-ca-box--wide' : '') + '" role="dialog" aria-modal="true" aria-labelledby="nt-ca-title">' +
        '<div class="nt-ca-hd"><p class="nt-ca-title" id="nt-ca-title">' + esc(opts.title) + '</p>' +
          (opts.msg ? '<p class="nt-ca-msg">' + esc(opts.msg) + '</p>' : '') + '</div>' +
        (opts.body ? '<div class="nt-ca-body">' + opts.body + '</div>' : '') +
        '<div class="nt-ca-ft">' +
          '<button type="button" class="nt-ca-btn" data-nt-ca-cancel>Cancel</button>' +
          '<button type="button" class="nt-ca-btn ' + (opts.okClass || 'nt-ca-btn--go') + '" data-nt-ca-ok' + (opts.okDisabled ? ' disabled' : '') + '>' + esc(opts.okText || 'Continue') + '</button>' +
        '</div>' +
      '</div>';
    function close() {
      document.removeEventListener('keydown', onKey);
      if (ov.parentNode) ov.parentNode.removeChild(ov);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    ov.addEventListener('click', function (e) {
      if (e.target === ov || e.target.closest('[data-nt-ca-cancel]')) { close(); return; }
      var ok = e.target.closest('[data-nt-ca-ok]');
      if (ok && !ok.disabled) opts.onOk(close, ok);
    });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(ov);
    var okBtn = ov.querySelector('[data-nt-ca-ok]');
    if (okBtn && !okBtn.disabled) okBtn.focus();
    return close;
  }

  /* The cart merges the new render in place (component-cart.js morphCart), so a removal needs no whole-cart
     shimmer: only the design being removed dims (Owen 2026-10-26, QA: "every other product gets greyed out").
     sectionText = the cart section from the save's own response, so it's one round trip, not two. If the line
     survives (a failed save), it comes back to full opacity. */
  function refresh(group, btn, sectionText) {
    if (typeof window.refreshCart !== 'function') { window.location.reload(); return; }
    window.refreshCart('notOpen', null, sectionText || undefined);
    setTimeout(function () {
      if (group && group.isConnected) group.style.opacity = '';
      if (btn && btn.isConnected) btn.disabled = false;
    }, 4000);
  }

  /* ---- Keep the slide-out cart in step with the by-size engine (Justin 10-26) ----
     "Add another" (another upload, a previous design, the builder's add-and-stay) adds to the cart and
     stays on the page. The engine updates the header badge itself, but the slide-out cart kept its old
     HTML: "SHOPPING CART (1) · Your cart is currently empty". Re-render it quietly after every engine
     add; the plain Add to Cart path leaves for /cart anyway, so a refresh there is harmless. */
  document.addEventListener('bsv4:added-to-cart', function () {
    var added = fileIds(); // the designs just added: the event fires before the engine resets
    setTimeout(function () {
      if (typeof window.refreshCart === 'function') window.refreshCart('notOpen');
    }, 300);
    backToUpload(added, 0);
  });

  /* After an add that stays on the page the engine resets for the next design: take the shopper back
     to the top, where the upload box is, and put keyboard focus on it (Justin 10-26). A manual eased
     scroll, because smooth scrollIntoView/scrollTo is silently swallowed on these pages. */
  function fileIds() {
    try {
      var st = window.__bsv4Bridge && window.__bsv4Bridge.getState();
      return ((st && st.files) || []).map(function (f) { return f.id; }).join('|');
    } catch (e) { return ''; }
  }
  /* Wait until the added designs have left the page — reset to empty, OR replaced straight away by
     the next design (Choose a previous design / a new upload from the Add-another box loads it in the
     same moment, so the page is only empty for an instant). Up to ~6s; a plain Add to Cart never
     resets — it is on its way to /cart. */
  function backToUpload(added, tries) {
    if (!added) return;
    if (fileIds() === added) {
      if (tries < 40) setTimeout(function () { backToUpload(added, tries + 1); }, 150);
      return;
    }
    var startY = window.pageYOffset;
    var focusZone = function () {
      var z = document.querySelector('[data-bsv4-dropzone]');
      if (z && z.offsetParent !== null) { try { z.focus({ preventScroll: true }); } catch (e) {} }
    };
    if (startY <= 0) { focusZone(); return; }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { window.scrollTo(0, 0); focusZone(); return; }
    var dur = Math.min(900, Math.max(350, startY * 0.22)), t0 = performance.now();
    var step = function (now) {
      var p = Math.min(1, (now - t0) / dur);
      window.scrollTo(0, startY * Math.pow(1 - p, 3));
      if (p < 1) requestAnimationFrame(step); else focusZone();
    };
    requestAnimationFrame(step);
  }

  /* ---- Clear cart ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-nt-cart-clear]');
    if (!btn) return;
    e.preventDefault();
    modal({
      title: 'Clear your cart?',
      msg: 'This removes every item from your cart. This can’t be undone.',
      okText: 'Clear cart',
      okClass: 'nt-ca-btn--danger',
      onOk: function (close, ok) {
        ok.disabled = true;
        ok.textContent = 'Clearing…';
        fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
          /* full page reload: an empty cart drops the blanks upsell + Share cart, which live outside the re-rendered cart form (Justin 2026-10-20) */
          .then(function () { window.location.reload(); }, function () { window.location.reload(); });
      }
    });
  });

  /* ---- Master X: remove every size of one design ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.nt-dg-remove-all');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    var keys = (btn.getAttribute('data-nt-remove-keys') || '').split(',').filter(Boolean);
    if (!keys.length) return;
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    btn.disabled = true;
    var group = btn.closest('.nt-design-group, .nt-blank-group');
    if (group) group.style.opacity = '.4';
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: 'helper-cart', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (j) { refresh(group, btn, j && j.sections && j.sections['helper-cart']); },
            function () { refresh(group, btn); });
  }, true);

  /* ---- Resolution → replacement order (My Orders + Recent Orders, Justin 2026-10-20) ----
     The NEW (reprint) order carries custom.reprint_order = the original; its row has
     data-nt-reprint-of. Under the original's red "Resolution – Reorder Blocked", the
     .nt-reso-new placeholder becomes "New Order NT-…": a link that fills the My Orders
     search (handled in my-orders-content) or opens My Orders with ?find= elsewhere. */
  function resoScan(root) {
    root = root || document;
    var map = {};
    root.querySelectorAll('[data-nt-reprint-of]').forEach(function (r) {
      var k = r.getAttribute('data-nt-reprint-of');
      if (k && !map[k]) map[k] = r.getAttribute('data-nt-order-name');
    });
    root.querySelectorAll('.nt-reso-new[data-nt-reso-for]').forEach(function (el) {
      var nm = map[(el.getAttribute('data-nt-reso-for') || '').replace(/^ro-/, '')];
      if (!nm || el.getAttribute('data-nt-filled') === nm) return;
      el.textContent = 'New Order ';
      var a = document.createElement('a');
      a.href = '/pages/welcome?tab=my-orders&find=' + encodeURIComponent(nm);
      a.setAttribute('data-ao-find-order', nm);
      a.textContent = nm;
      a.style.cssText = 'color:#019AFF;text-decoration:underline;font-weight:600;';
      a.addEventListener('click', function (e) { e.stopPropagation(); });
      el.appendChild(a);
      el.hidden = false;
      el.setAttribute('data-nt-filled', nm);
    });
  }
  window.NTResoLink = { scan: resoScan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { resoScan(); });
  else resoScan();

  /* ---- Reorder review ---- */
  function readLines(btn) {
    var el = btn.previousElementSibling;
    while (el && !(el.classList && el.classList.contains('nt-rr-data'))) el = el.previousElementSibling;
    if (!el && btn.parentNode) el = btn.parentNode.querySelector('.nt-rr-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (err) { return null; }
  }

  function row(l, oos) {
    var q = parseInt(l.q, 10) || 0;
    return '<div class="nt-ca-row' + (oos ? ' nt-ca-row--oos' : '') + '">' +
      (l.i ? '<img class="nt-ca-th" src="' + esc(l.i) + '" alt="" loading="lazy" onerror="this.style.visibility=\'hidden\'">' : '<span class="nt-ca-th"></span>') +
      '<span class="nt-ca-nm">' + esc(dec(l.n)) + (l.s ? '<span class="nt-ca-sub">' + esc(dec(l.s)) + '</span>' : '') + '</span>' +
      (oos ? '<span class="nt-ca-tag">Out of Stock</span>' : '<span class="nt-ca-q">Qty ' + q + '</span>') +
    '</div>';
  }

  /* centred "Adding your items to cart" overlay; hidden once the cart re-renders (cart-updated) or after 20s */
  var loadEl = null, loadTimer = null;
  function hideLoading() {
    clearTimeout(loadTimer);
    if (loadEl && loadEl.parentNode) loadEl.parentNode.removeChild(loadEl);
    loadEl = null;
  }
  function showLoading() {
    hideLoading();
    loadEl = document.createElement('div');
    loadEl.className = 'nt-ca-load';
    loadEl.setAttribute('role', 'status');
    loadEl.innerHTML = '<div class="nt-ca-spin"></div><p>Adding your items to cart</p><p class="nt-ca-load-sub">Review, edit, or remove items before checkout</p>';
    document.body.appendChild(loadEl);
    loadTimer = setTimeout(hideLoading, 20000);
  }
  document.addEventListener('cart-updated', function () { if (loadEl) setTimeout(hideLoading, 150); });

  window.NTReorderReview = {
    loading: showLoading,
    done: hideLoading,
    open: function (btn, onContinue) {
      var lines = readLines(btn);
      var go = onContinue;
      onContinue = function () { showLoading(); go(); };
      if (!lines) { onContinue(); return; }
      var add = [], oos = [];
      lines.forEach(function (l) {
        if (l.o || !(parseInt(l.q, 10) > 0)) oos.push(l); else add.push(l);
      });
      /* only prompt when something is out of stock; otherwise reorder straight away (Justin 2026-10-20) */
      if (!oos.length) { onContinue(); return; }
      var body = '';
      if (add.length) body += '<p class="nt-ca-sec">Will be added (' + add.length + ')</p>' + add.map(function (l) { return row(l, false); }).join('');
      if (oos.length) body += '<p class="nt-ca-sec">Out of stock — not added (' + oos.length + ')</p>' + oos.map(function (l) { return row(l, true); }).join('');
      var order = btn.getAttribute('data-corder-id') || '';
      modal({
        wide: true,
        title: 'Buy Again ' + order,
        msg: add.length ? 'Review what will be added to your cart.' : 'Everything in this order is out of stock right now.',
        body: body,
        okText: 'Continue',
        okDisabled: !add.length,
        onOk: function (close) { close(); onContinue(); }
      });
    }
  };
})();
